import { render } from "./LeaguesTablesWidget.vue?vue&type=template&id=abfd791e&ts=true"
import script from "./LeaguesTablesWidget.vue?vue&type=script&lang=ts"
export * from "./LeaguesTablesWidget.vue?vue&type=script&lang=ts"

import "./LeaguesTablesWidget.vue?vue&type=style&index=0&id=abfd791e&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__